<template>
   <div>
        <div>
            <v-form
               ref="create_traits"
               v-model="valid_create_traits"
            >
               
               <div>
                  
                  <!-- Mansioni -->
                  <div>
                     <registration-title :title="$t('Mansioni')">
                        {{$t('Sono disponibile per i seguenti lavori')}}
                     </registration-title>
                     
                     <div>
                        <div v-if="user && all_experiences && all_experiences.length" class="grid md:grid-cols-2 lg:grid-cols-3">
                           <div v-for="(exp,index) in all_experiences" :key="index">
                              <flip-check
                                 outlined
                                 :check="user[exp.label] ? true : false"
                                 :label="exp.name"
                                 @changeCheck="user[exp.label] = user[exp.label] ? null : '1'"
                                 scale=".7"
                              >
                              </flip-check>
                           </div>
                           <div class="md:col-span-2 lg:col-span-3">
                              <div>
                                 <v-text-field
                                    class="input_transparent input_transparent__center"
                                    :rules="disable_rules ? [] : [validation_rules.once_experience]"
                                    v-model="once_experience"
                                 ></v-text-field>
                              </div>
                           </div>
                        </div>  
                     </div>
                  </div>
                  

                  <!-- Caratteristiche fisiche -->
                  <div class="mt-5">
                     <registration-title :title="$t('Caratteristiche fisiche')"></registration-title>
                     <div>
                        <div class="grid md:grid-cols-2 gap-2">

                           <div class="md:col-span-2">
                              <b class="uppercase">{{$t('Caratteristiche')}}</b>
                           </div>
                     
                           <!-- Altezza -->
                           <div class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <div>{{$t('Altezza')}}:</div>
                                    <v-icon v-if="!user.altezza" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.altezza }} cm</span>
                                 </span>
                                 <v-text-field
                                    class="input_transparent input_transparent__absolute"
                                    :rules="disable_rules ? [] : [validation_rules.required_not0]"
                                    v-model="user.altezza"
                                 ></v-text-field>
                              </v-subheader>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.altezza"
                                 :max="altezza.max"
                                 :min="altezza.min"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>
                           
                           <!-- Taglia -->
                           <div class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between relative w-[100%]">
                                    <div>{{$t('Taglia')}}:</div>
                                    <v-icon v-if="!user.taglia" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else class="taglia-mobile">{{ euit(user.taglia) }}</span>
                                 </span>
                              </v-subheader>
                              <v-text-field
                                 class="input_transparent input_transparent__absolute"
                                 :rules="disable_rules ? [] : [validation_rules.required_not0]"
                                 v-model="user.taglia"
                              ></v-text-field>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.taglia"
                                 :max="taglia.max"
                                 :min="taglia.min"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>
                           
                           <!-- Scarpe -->
                           <div class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <div>{{$t('Scarpe')}}:</div>
                                    <v-icon v-if="!user.scarpe" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.scarpe }}</span>
                                 </span>
                              </v-subheader>
                              <v-text-field
                                 class="input_transparent input_transparent__absolute"
                                 :rules="disable_rules ? [] : [validation_rules.required_not0]"
                                 v-model="user.scarpe"
                              ></v-text-field>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.scarpe"
                                 :max="scarpe.max"
                                 :min="scarpe.min"
                                 step="0.5"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>

                           <div class="md:col-span-2">
                              <v-divider></v-divider>
                           </div>

                           <div class="md:col-span-2">
                              <b class="uppercase">{{$t('Misure')}}</b>
                           </div>

                           <!-- seno -->
                           <div class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <span v-if="user.genere == 'uomo'">{{$t('Petto')}}: </span>
                                    <span v-if="user.genere == 'donna' || user.genere == 'altro'">{{$t('Seno/Petto')}}: </span>
                                    <v-icon v-if="!user.seno" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.seno }} cm</span>
                                 </span>
                              </v-subheader>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.seno"
                                 :max="seno.max"
                                 :min="seno.min"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>

                           <!-- vita -->
                           <div v-if="user.genere != 'uomo'" class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <div>{{$t('Vita')}}:</div>
                                    <v-icon v-if="!user.vita" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.vita }} cm</span>
                                 </span>
                              </v-subheader>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.vita"
                                 :max="vita.max"
                                 :min="vita.min"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>

                           <!-- fianchi -->
                           <div class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <div>{{$t('Fianchi')}}:</div>
                                    <v-icon v-if="!user.fianchi" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.fianchi }} cm</span>
                                 </span>
                              </v-subheader>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.fianchi"
                                 :max="fianchi.max"
                                 :min="fianchi.min"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>

                           <div v-if="user.genere != 'uomo'" class="md:col-span-2">
                              <v-divider></v-divider>
                           </div>

                           <div v-if="user.genere != 'uomo'" class="md:col-span-2">
                              <b class="uppercase">{{$t('Reggiseno')}}</b>
                           </div>

                           <!-- reggisenoTaglia - NO UOMO -->
                           <div v-if="user.genere != 'uomo'" class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <div>{{$t('Reggiseno taglia')}}:</div>
                                    <v-icon v-if="!user.reggisenoTaglia" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.reggisenoTaglia }}</span>
                                 </span>
                              </v-subheader>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="user.reggisenoTaglia"
                                 :max="reggisenoTaglia.max"
                                 :min="reggisenoTaglia.min"
                                 thumb-label
                                 hide-details
                              ></v-slider>
                           </div>

                           <!-- reggisenoCoppa - NO UOMO -->
                           <div v-if="user.genere != 'uomo'" class="flex items-center gap-2 relative">
                              <v-subheader class="flex gap-1 w-[120px] md:w-[250px] pl-0 min-w-[fit-content]">
                                 <span class="flex justify-between w-[100%]">
                                    <div>{{$t('Reggiseno coppa')}}:</div>
                                    <v-icon v-if="!user.reggisenoCoppa" color="red">mdi-circle-off-outline</v-icon>
                                    <span v-else>{{ user.reggisenoCoppa }}</span>
                                 </span>
                              </v-subheader>
                              <v-slider
                                 class="h-[fit-content]"
                                 v-model="reggisenoCoppa.value"
                                 :tick-labels="reggisenoCoppa.ticks"
                                 :max="reggisenoCoppa.ticks.length - 1"
                                 step="1"
                                 ticks="always"
                                 thumb-label
                                 hide-details
                              >
                                 <template v-slot:thumb-label="{}">
                                    {{user.reggisenoCoppa ? user.reggisenoCoppa : ''}}
                                 </template>
                              </v-slider>
                                 <!-- tick-size="4" -->
                           </div>

                           <div class="md:col-span-2">
                              <v-divider></v-divider>
                           </div>

                           <div class="md:col-span-2">
                              <b class="uppercase">{{$t('Capelli')}}</b>
                           </div>

                           <!-- capelliTipologia -->
                           <div>
                              <v-autocomplete
                                 :label="$t('Capelli tipologia')"
                                 v-model="user.capelliTipologia"
                                 :items="capelliTipologia"
                                 item-text="label"
                                 item-value="value"
                                 hide-details="auto"
                                 outlined
                                 dense
                              ></v-autocomplete>
                              <v-text-field
                                 class="input_transparent"
                                 :rules="disable_rules ? [] : [validation_rules.required_not0]"
                                 v-model="user.capelliTipologia"
                              ></v-text-field>
                              
                           </div>

                           <!-- Capelli -->
                           <div>
                              <!-- <div v-if="!custom_hair"> -->
                                 <v-autocomplete
                                    :label="$t('Capelli')"
                                    v-model="user.capelli"
                                    :items="capelli"
                                    item-text="label"
                                    item-value="value"
                                    hide-details="auto"
                                    :disabled="user.capelliTipologia == 'Calvi'"
                                    outlined
                                    dense
                                 ></v-autocomplete>
                                 <v-text-field
                                    class="input_transparent"
                                    v-model="user.capelli"
                                 ></v-text-field>
                              <!-- </div> -->
                              <!-- <div v-else>
                                 <v-text-field
                                    :label="$t('Capelli')"
                                    v-model="user.capelli"
                                    outlined
                                    dense
                                 ></v-text-field>
                              </div>

                              <flip-check
                                 outlined
                                 :check="custom_hair"
                                 :label="$t('Ho un altro colore di capelli')"
                                 @changeCheck="() => {
                                    user.capelli = '',
                                    custom_hair = !custom_hair
                                 }"
                                 scale=".6"
                              >
                              </flip-check> -->
                              
                           </div>

                           <div class="md:col-span-2">
                              <v-divider></v-divider>
                           </div>

                           <div class="md:col-span-2">
                              <b class="uppercase">{{$t('Occhi')}}</b>
                           </div>

                           <!-- occhi -->
                           <div>
                              <v-autocomplete
                                 :label="$t('Occhi')"
                                 v-model="user.occhi"
                                 :items="occhi"
                                 item-text="label"
                                 item-value="value"
                                 hide-details="auto"
                                 outlined
                                 dense
                              ></v-autocomplete>
                              <v-text-field
                                 class="input_transparent"
                                 :rules="disable_rules ? [] : [validation_rules.required_not0]"
                                 v-model="user.occhi"
                              ></v-text-field>
                              
                           </div>

                        </div>
                     </div>
                  </div>
               </div>

               <div class="flex justify-between items-end mt-5 pt-1 border-t border-[#e5e7eb]">
                  <!-- <a color="#808080" @click="logout">Logout</a> -->
                  <v-btn color="grey" dark :loading="btn_loading" @click="$emit('nextStep',3)">{{$t('Indietro')}}</v-btn>
                  <v-btn color="green" dark :loading="btn_loading" @click="nextStep()">{{$t('Avanti')}}</v-btn>
               </div>
            </v-form>
        </div>
   </div>
</template>

<script>
// import moment from "moment";

export default {
    data() {
      return {
         btn_loading: false,
         disable_rules: true,
         valid_create_traits: true,
         custom_hair: false,
      };
   },
   computed: {
      user() {
         let _user = this.$store.getters['user/user']
         this.setReggisenoCoppa(_user)
         return _user
      },
      once_experience(){
         let _once_experience = this.all_experiences.find(exp => this.user[exp.label])
         return _once_experience ? true : false
      }
   },
   watch: {
      'user.taglia'(){
         if(this.user){
            if( this.user.taglia <= this.taglia.min ){   
               this.user.taglia = null
            }
         }
      },
      'user.altezza'(){
         if(this.user){
            if( this.user.altezza <= this.altezza.min ){
               this.user.altezza = null
            }
         }
      },
      'user.scarpe'(){
         if(this.user){
            if( this.user.scarpe <= this.scarpe.min ){
               this.user.scarpe = null
            }
         }
      },
      'user.seno'(){
         if(this.user){
            if( this.user.seno <= this.seno.min ){
               this.user.seno = null
            }
         }
      },
      'user.reggisenoTaglia'(){
         if(this.user){
            if( this.user.reggisenoTaglia <= this.reggisenoTaglia.min ){
               this.user.reggisenoTaglia = null
            }
         }
      },
      'user.vita'(){
         if(this.user){
            if( this.user.vita <= this.vita.min ){
               this.user.vita = null
            }
         }
      },
      'user.fianchi'(){
         if(this.user){
            if( this.user.fianchi <= this.fianchi.min ){
               this.user.fianchi = null
            }
         }
      },
      'reggisenoCoppa.value'(){
         if( !this.reggisenoCoppa.value  ){
               this.user.reggisenoCoppa = null
         } else {
               this.user.reggisenoCoppa = this.reggisenoCoppa.ticks[this.reggisenoCoppa.value]
         }
      },
   },
   methods: {
      async nextStep(){
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.create_traits.validate();
         if(valid){
            this.sendEdit()
         }
      },
      async sendEdit(){
         this.btn_loading = true
         let body = {
            altezza: this.user.altezza,
            taglia: this.user.taglia,
            scarpe: this.user.scarpe,
            capelli: this.user.capelli,
            capelliTipologia: this.user.capelliTipologia,
            occhi: this.user.occhi,
            registrazioneCompletata: this.user.registrazioneCompletata < 6 ? 6 : this.user.registrazioneCompletata, // salta il 5 e va al 6 (salta il fiscale)
            seno: this.user.seno,
            fianchi: this.user.fianchi
         }

         if(this.user.genere != "uomo"){
            body.reggisenoTaglia = this.user.reggisenoTaglia
            body.vita = this.user.vita
            body.reggisenoCoppa = this.user.reggisenoCoppa
         }

         this.all_experiences.forEach(exp => {
            body[exp.label] = this.user[exp.label]
         });

         let response = await this.$store.dispatch('user/editUser',body)
         if(response.response.error){
            this.btn_loading = false
            return
         }
         this.$emit("nextStep",6) // salta il 5 e va al 6 (salta il fiscale)
         this.btn_loading = false
      },
      setReggisenoCoppa(_user){
         if(_user && _user.reggisenoCoppa)
            this.reggisenoCoppa.value = this.reggisenoCoppa.ticks.findIndex(el => el == _user.reggisenoCoppa)
      }
   },
};
</script>

<style lang="scss" scoped>
/*  */
</style>
